export const TOGGLE = 'Header/TOGGLE';

export function toggle( open: boolean ) {
  return ( dispatch: any ) => {
    dispatch({ type: TOGGLE, payload: open });
  };
}
